import { Box, FormControlLabel, Grid, Slider, Switch, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ComboBox from '../autoComplete/ComboBox';
import ApiService from '../../utils/ApiService';

function ToneOfVoice(props) {
    // const defaultToneO
    // const [selectedTone, setSelectedTone] = useState(70)
    const [toneOfVoiceList, setToneOfVoiceList] = useState([])
    const [selectedTone, setSelectedTone] = useState([])
    const [hasTag, setHasTag] = useState(false);
    const [selectedWordLimit, setSelectedWordLimit] = useState(70);

    const handleSliderChange = (event, newValue) => {
        // console.debug("genAI : handleSliderChange : newValue : ", newValue);
        setSelectedWordLimit(newValue);
        if (props?.wordLimitChangeHandler)
            props.wordLimitChangeHandler(newValue)
    };

    const onGenerateHashTagHandler = (event) => {
        // console.debug("genAI : onGenerateHashTagHandler : event : ", event);
        setHasTag(event.target.checked);
        if (props?.hasTagStatusChangeHandler) {
            props.hasTagStatusChangeHandler(event.target.checked);
        }
    };

    function toneOfVoiceOnChangeHandler(item) {
        // console.debug("genAI : ToneOfVoice : toneOfVoiceOnChangeHandler : item : ", item);
        setSelectedTone(item);
        if (props?.toneOfVoiceChangeHandler) {
            props.toneOfVoiceChangeHandler(item);
        }
    }

    useEffect(function () {
        ApiService.get('toneOfVoice').then(response => {
            let rData = response.data.data;
            // console.debug("ToneOfVoice : useEffect : rData First : ", rData);
            rData = rData?.map((option) => {
                return { label: option.name, ...option }
            })
            // console.debug("ToneOfVoice : useEffect : rData : ", rData);
            setToneOfVoiceList(rData)
        }).catch((error) => {
            console.debug(error)
        })
        // console.debug("ToneOfVoice : useEffect : selectedWordLimit : ", selectedWordLimit);
        if (props?.wordLimitChangeHandler)
            props.wordLimitChangeHandler(selectedWordLimit)
    }, []);

    return (
        <Box>
            <Box>
                <Grid container spacing={2} sx={{ my: 1, display: 'flex', alignItems: 'center' }}>
                    <Grid item xs={6} sx={{ pt: '8px !important' }}>
                        <ComboBox
                            options={toneOfVoiceList}
                            onChangeHandler={toneOfVoiceOnChangeHandler}
                            // onChange={(event, newValue) => {
                            //     setSelectedTone(newValue);
                            // }}

                            renderInput={(params) => {
                                return (
                                    <TextField {...params} label="Tone of voice" />
                                )
                            }
                            }

                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Box>
                            <FormControlLabel
                                control={
                                    <Switch checked={hasTag} onChange={onGenerateHashTagHandler} name="gilad" />
                                }
                                label={<Typography variant='subtitle2' >Generate hashtags</Typography>}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            <Box>
                <Typography variant="subtitle2" >Approximate words</Typography><br />
                <Slider defaultValue={selectedWordLimit} aria-label="Default" valueLabelDisplay="auto"
                    value={selectedWordLimit}
                    min={0}
                    max={100}
                    onChange={handleSliderChange} />
            </Box>
        </Box>

    );
}

export default ToneOfVoice;